import { library } from '@fortawesome/fontawesome-svg-core';

import { collegialIcons } from './iconDefinitions/collegialIcons';
import { extraIcons } from './iconDefinitions/extraIcons';
import { fontAwesomeIcons } from './iconDefinitions/fontAwesomeIcons';

export function bootstrapIcons(): void {
  library.add(...fontAwesomeIcons, ...collegialIcons, ...extraIcons);
}
